import * as React from 'react';
type Props = {
  className?: string;
};
export function ChefsPick({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Chefs pick"
      className={className}
    >
      <path
        d="M12.6295 16.4916C12.6295 16.4916 12.3759 23.549 16.1899 27.4317C16.1899 27.4317 19.7769 31.4902 23.7054 27.3652C23.7054 27.3652 27.3128 23.7035 27.2024 16.4894M7.25108 24.7481C7.25108 24.7481 10.0916 31.0204 8.32472 34.4591C8.32472 34.4591 7.45353 36.1752 8.91573 36.5034C8.91573 36.5034 20.2513 39.5494 30.8364 36.5034C31.2863 36.3575 32.178 35.8319 31.36 34.4312C31.36 34.4312 30.8078 29.1413 32.7424 24.7567M29.6728 36.8144L29.8732 36.7629M37.1188 12.2807C36.7445 6.08134 32.3682 2.59768 27.9979 5.07743C27.6825 5.25914 27.3773 5.45968 27.0838 5.67806C25.2698 3.05888 22.734 1.42859 19.918 1.42859C17.1306 1.42859 14.6173 3.02455 12.8074 5.59011C12.5479 5.40408 12.2789 5.23293 12.0017 5.07743C7.63145 2.59768 3.25508 6.0792 2.88084 12.2829C2.49229 18.7804 6.93614 27.1979 12.6949 28.0924C13.4557 28.2082 14.1735 27.895 14.8177 27.2708C16.3106 28.515 18.0488 29.2443 19.918 29.2443C21.8199 29.2443 23.5909 28.4849 25.1022 27.1957C25.7668 27.8736 26.5132 28.2146 27.3067 28.0902C33.0635 27.1979 37.5114 18.7783 37.1188 12.2807Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
